// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"259d43de","147":"396c2592","348":"317cb714","737":"e12c8a2c","787":"d7ece244","940":"b04012bb"}[chunkId] + ".chunk.js";
};